import React, { useEffect, useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import ApplyCastingModal from "@/components/ApplyCastingModal";

export default function CastingCalls() {
  const [calls, setCalls] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { api.get("/casting-calls").then((r) => setCalls(r.data)); }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0B]">
      <Header />
      <section className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-16">
        <div className="sv-overline mb-3">Casting Opportunities</div>
        <h1 className="font-serif-hero text-4xl lg:text-6xl">Fresh briefs, curated daily.</h1>
        {calls.length === 0 && (
          <div className="mt-10 sv-card p-8 text-center text-sm text-[#8A8478]">
            No open casting calls right now. Check back soon.
          </div>
        )}
        <div className="grid md:grid-cols-2 gap-6 mt-10">
          {calls.map((c) => (
            <div key={c.casting_id} className="sv-card p-6 flex flex-col" data-testid={`casting-card-${c.casting_id}`}>
              <div className="font-mono-label text-[10px] text-[#C5A059]">{c.location}</div>
              <div className="font-serif-editorial text-2xl mt-1 text-[#F4E4BC]">{c.project}</div>
              <div className="text-sm text-[#CDC7BA]">{c.role}</div>
              {c.requirements && <p className="mt-3 text-sm text-[#C5A059]">{c.requirements}</p>}
              <div className="mt-4 flex justify-between text-xs text-[#8A8478]">
                <span>Shoot: {c.shoot_date || "TBD"}</span>
                <span>Budget: {c.budget || "On request"}</span>
              </div>
              <div className="mt-5 pt-5 border-t border-[rgba(255,255,255,0.06)] flex justify-end">
                <button onClick={() => setActive(c)} className="sv-btn-primary text-xs" data-testid={`apply-now-${c.casting_id}`}>
                  Apply Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
      {active && <ApplyCastingModal call={active} onClose={() => setActive(null)} />}
      <Footer />
    </div>
  );
}
